/** Shared help mailbox; update here when contact details change. */
export const REP_ASSIST_HELP_EMAIL = "RepAssistHelp@unither.com";

export const LoadingMessages = [
  "Thinking...",
  "Analyzing data...",
  "Gathering insights...",
  "Compiling the answer...",
];

export const RBD_DIRECTORY = Object.freeze({
  "gbottorff@unither.com": "GREG BOTTORFF",
  "brice@unither.com": "BRAD RICE",
  "tyork@unither.com": "TIM YORK",
  "mburkitt@unither.com": "MARCY BURKITT",
  "wbrazeau@unither.com": "WENDY BRAZEAU",
  "lford@unither.com": "LEIGH FORD",
  "amikesell@unither.com": "AMY MIKESELL",
  "dwhite@unither.com": "DAVID WHITE",
  "jboesen@unither.com": "JOSH BOESEN",

  "aho@unither.com": "ABEL HO",
  "jlittle@unither.com": "JAMIE LITTLE",
  "kekelly@unither.com": "KEITH KELLY",
  "jmichael@unither.com": "MIKE MICHAEL",
  "ssurles@unither.com": "STEPHEN SURLES",
  "abir@unither.com": "TONY BIR",
  "pconn@unither.com": "PRISCILLA CONN",
  "asimmons@unither.com": "AL SIMMONS",
  "dzinger@unither.com": "DAVE ZINGER",
  "mturcotte@unither.com": "MATTHEW TURCOTTE",
  "gtaylor@unither.com": "GINEVE TAYLOR",
  "rpowell@unither.com": "ROLAND POWELL",
  "rskinner@unither.com": "ROB SKINNER",
  "vbetancourt@unither.com": "VERONICA BETANCOURT",
  "cthompson@unither.com": "CASEY THOMPSON",
  "sstutts@unither.com": "STACY STUTTS",
  "rusmith@unither.com": "RUTH SMITH",
  "jkeirn@unither.com": "JODI KEIRN",
  "jroach@unither.com": "JOHN ROACH",
  "ashort@unither.com": "AMY SHORT",
  "bbricker@unither.com": "BARBY BRICKER",
  "dmai@unither.com": "DAN MAI",
  "kclifford@unither.com": "KAREN CLIFFORD",
  "kferguson@unither.com": "KRISTI FERGUSON",
  "mthornton@unither.com": "MELANIE THORNTON",
  "tbradley@unither.com": "TARA BRADLEY",
  "dpapp@unither.com": "  DIANE PAPP",
  "gherrera@unither.com": "BILL HERRERA",
  "jmartin@unither.com": "JENA MARTIN",
});

/** Shared product-group filter value when viewing aggregated metrics. */
export const ALL_PRODUCT_GROUP_OPTION = "All";

/** Leadership-only dashboard filter options (includes "All"). */
export const LEADERSHIP_PRODUCT_LIST = Object.freeze([
  ALL_PRODUCT_GROUP_OPTION,
  "CPS",
  "ALD",
  "ROCS-Remodulin",
  "ROCS-Orenitram",
]);

/**
 * Maps dashboard filter selections to product group + sales group.
 * Used for leadership filter keys (e.g. CPS1, ROCPS-Remodulin) and for
 * resolving sales-rep product groups (e.g. TYVASO) to sales groups (CPS1, CPS3).
 */
export const PRODUCT_SALES_GROUP_MAP = Object.freeze({
  CPS: { product: "TYVASO", salesGroup: "CPS" },
  ALD: { product: "TYVASO", salesGroup: "ALD" },
  "ROCS-Remodulin": { product: "REMODULIN", salesGroup: "ROCS" },
  "ROCS-Orenitram": { product: "ORENITRAM", salesGroup: "ROCS" },
});

export const DEFAULT_TILES = [
  { title: "How am I tracking against my goals for this quarter?" },
  { title: "Suggest some high growth potential HCPs to engage with" },
  { title: "Help me prep for my call with Dr [insert HCP]" },
  {
    title:
      "Are there any significant trends to be aware of in my territory?​​",
  },
];

export const RBD_TILES = [
  {
    title:
      "Help me prep for a performance review call with [insert sales rep]​",
  },
  { title: "What are the significant trends in my region?" },
  { title: "What non-target HCPs have a high growth potential?" },
  { title: "How many starts does [territory] have this quarter?​" },
];

export const LEADERSHIP_TILES = [
  { title: "Summarize the national performance of [ProductGroup]" },
  { title: "Summarize key trends in the nation for [ProductGroup]" },
  {
    title:
      "How is the [SalesGroup] group tracking towards the reach and frequency goals?",
  },
  {
    title:
      "Summarize the performance of [SalesGroup] [region] this quarter",
  },
];